import { Link, NavLink, useLocation } from 'react-router-dom';
import { useState } from 'react';
import cn from 'classnames';
import { useScreenWidth } from 'hooks/useScreenWidth';
import { pathnames } from 'constants/pathnames';
import { HEADER_DESKTOP_MIN_WIDTH } from 'constants/breakpoints';
import { Container } from 'components/Container';
import { Button } from 'components/Button';
import { Menu } from 'components/Menu';
import logoSmallDark from 'assets/icons/logos/ecds-compressed-dark.svg';
import logoSmall from 'assets/icons/logos/ecds-compressed.svg';
import logo from 'assets/icons/logos/ecds.svg';
import styles from 'components/Header/Header.scss';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const screenWidth = useScreenWidth();
  const { pathname } = useLocation();

  const {
    mainPage,
    managementPage,
    documentsPage,
    contactsPage,
    logosPage,
    ballroomPage,
    calendarPage,
    newsPage,
    membersPage,
  } = pathnames;
  const darkHeaderPages = [
    managementPage,
    documentsPage,
    contactsPage,
    logosPage,
    ballroomPage,
    newsPage,
    calendarPage,
    membersPage,
  ];
  const aboutUsPages = [managementPage, documentsPage, contactsPage, logosPage];

  const handleAboutUsLinkClick = (e) => {
    if (aboutUsPages.includes(pathname)) {
      e.preventDefault();
    }
  };

  const currentPathName = '/' + pathname.split('/')[1];
  const isPageDark = darkHeaderPages.includes(currentPathName);

  return (
    <>
      <header className={styles.headerWrapper}>
        <Container>
          <div className={cn(styles.header, { [styles.headerDark]: isPageDark })}>
            <Link to={mainPage} className={styles.logo}>
              <img
                src={screenWidth > HEADER_DESKTOP_MIN_WIDTH ? logo : isPageDark ? logoSmallDark : logoSmall}
                alt='European Confederation of Dance Sports logo'
              />
              {/* Kept in the DOM below the breakpoint too (just visually hidden)
                  rather than left out entirely — search crawlers render at
                  narrow viewports, so a JS-conditional `screenWidth > HEADER_DESKTOP_MIN_WIDTH && …`
                  meant the brand name was never in what they saw. */}
              <span className={cn({ [styles.logoTextHidden]: screenWidth <= HEADER_DESKTOP_MIN_WIDTH })}>
                European Confederation of Dance Sports
              </span>
            </Link>
            <nav>
              <ul className={styles.navigation}>
                {screenWidth > HEADER_DESKTOP_MIN_WIDTH && (
                  <li>
                    <NavLink
                      className={cn(styles.navigationLink, {
                        [styles.active]: aboutUsPages.includes(currentPathName),
                      })}
                      to={managementPage}
                      onClick={handleAboutUsLinkClick}
                      {...(aboutUsPages.includes(currentPathName) && {
                        tabIndex: -1,
                      })}
                    >
                      About us
                    </NavLink>
                  </li>
                )}
                <li>
                  <Button
                    className={styles.navigationLink}
                    text={screenWidth > HEADER_DESKTOP_MIN_WIDTH ? 'Menu' : <div className={styles.menuIcon} />}
                    onClick={() => setIsMenuOpen(true)}
                    noStyle
                  />
                </li>
              </ul>
            </nav>
          </div>
          {screenWidth > HEADER_DESKTOP_MIN_WIDTH && <Menu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />}
        </Container>
      </header>
      {screenWidth <= HEADER_DESKTOP_MIN_WIDTH && <Menu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />}
    </>
  );
};
